import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleWelcomeHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/profiles/welcome` URL — the other spelling the Ember
 * router answers, since it flag-swaps the `people`/`profiles` segment per
 * account. It always forwards to the Hydra People list, same as the
 * `/journeys/people/welcome` twin.
 */
function JourneysProfilesWelcomeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleWelcomeHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome')({
  component: JourneysProfilesWelcomeRoute,
});
